import React, {createRef, useEffect, useState} from 'react'
import {Modal, Button, Form, Checkbox, Spin} from 'antd'
import { connect } from 'react-redux'
import './index.scss'
import {InputSearchIco, ModalCloseIco, ModalErrorIco, ModalSuccessIco, SpinnerIco} from '../../../modules/CustomIcons'
import InputField from "components/InputField";
import {OWNACCOUNT} from "constants/constants";
import {checkAmountForRequest, resetForm} from "../../services/helper";
import {upsertTemplate} from "../../services/Transfers/Templates";
import {leftMenuToggle, saveTemplateLoading} from "store/actions/home";
import {getCurrentCompany} from "../../services/user";
import {addActiveCompanyData} from "store/actions/user";
import {useHistory, useLocation} from "react-router-dom";
import store from "../../../../config/store";
import {LoginActionTypes} from "store/types/login";
import {useActions} from "hooks/useActions";
import { useTranslation } from 'react-i18next'


const SaveAsTemplate: React.FC<any> = ({ ownProps, leftMenuStatus, companyData }) => {
  const {t} = useTranslation()
  let custom_class = ownProps.className || ''
  const [ModalVisible, setModalVisible] = useState<boolean>(ownProps.visible || false)
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [isFavorite, setIsFavorite] = useState<boolean>(false);
  const [success,setSuccess] = useState(false)
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const { saveTemplateLoading } = useActions()
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {

    setModalVisible(old_value => ownProps.visible);

    form.setFieldsValue({
      'templateName': ''
    });
  }, [ownProps.visible, companyData])

  const onClose = () => {
    ownProps.onClose(old_value => false);

    setModalVisible(false)
    setShowSuccess(false)
  }

  const onChange = (e: any) => {
    setIsFavorite(e.target.checked);
  };

  const createNewTemplate = (args : any) => {
    console.log(ownProps)
    if(ownProps.tableData !== undefined ) {
      try {
        setLoading(true)
        ownProps.tableData.AMOUNT = checkAmountForRequest(ownProps.tableData?.AMOUNT);
        ownProps.tableData.COMMAMOUNT = checkAmountForRequest(ownProps.tableData?.COMMAMOUNT);
        ownProps.tableData.PMTCUSTID = null;
        console.log(ownProps.tableData)
        delete ownProps.tableData.HISTORY_DETAILS 
        delete ownProps.tableData.SIGN_DETAIL
     console.log(ownProps)
        console.log(ownProps.tableData)
        
        const request_data = {
          templateId: null,
          templateName: args.templateName,
          trnType: ownProps.tableData?.trnType,
          isFavorite: isFavorite ? 'Y' : 'N',
          trnData: ownProps.tableData
        }
        upsertTemplate(request_data).then(res => {
          if(res?.detail==='SUCCESS')
            { setShowSuccess(true);
             setLoading(false)
             setSuccess(true)
           
           }
             else{
               setShowSuccess(true);
               setLoading(false)
               setSuccess(false)
             }
          saveTemplateLoading()
          setIsFavorite(old_data => false)
          
          
        })
      } catch (e) {
        onClose();
        setLoading(false)
      }
    } else {
      setLoading(true)
      ownProps.currentForm.validateFields().then(input_list => {
        input_list.AMOUNT = checkAmountForRequest(input_list.AMOUNT);
        input_list.COMMAMOUNT = checkAmountForRequest(input_list.COMMAMOUNT);
        input_list.PMTCUSTID = null;
        input_list.transferDocs = ownProps.transferDocs
        input_list.pmtCurr = ownProps.amountCurr
        console.log(input_list);
        const request_data = {
          templateId: null,
          templateName: args.templateName,
          trnType: ownProps.trnType,
          isFavorite: isFavorite ? 'Y' : 'N',
          trnData: input_list
        }

        upsertTemplate(request_data).then(res => {
          console.log(res)
          saveTemplateLoading()
          
          //resetForm(form);
          //resetForm(ownProps.currentForm);
          setIsFavorite(old_data => false)
          if(res.detail==='SUCCESS')
         { setShowSuccess(true);
          setLoading(false)
          setSuccess(true)
        
        }
          else{
            setShowSuccess(true);
            setLoading(false)
            setSuccess(false)
          }
          // history.push({
          //   pathname: location.pathname,
          //   state: {random : Math.random()}
          // });


        })
      }).catch(args => {

        onClose();

      })
    }
  }


  return (
    <>
      <Modal
          title={t("newTransfer.saveAsTemplate")}
          closeIcon={<ModalCloseIco />}
          centered
          visible={ModalVisible}
          onOk={onClose}
          onCancel={onClose}
          width={531}
          className={`manage_faster_menus swift_modal template_list_popup_modal save_as_template_modal template_modal ${custom_class}`}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
      >

        {
          !showSuccess ? <Form
              layout="vertical"
              onFinish={createNewTemplate}
              autoComplete="off"
              form={form}
              className='full'
          >
            <InputField
                labelItem={t("transfers.templateName")}
                placeholder=""
                className={'no_flex isDisabled amount_input'}
                name={'templateName'}
                form={form}
                required={true}
                maxLength={60}
                notValid={''}
                // allowLatinWithSomeSymbols={true}
            />

            <Checkbox
                form={form}
                checked={isFavorite}
                name={'isFavorite'}
                onChange={onChange}
            >
              {t("transfers.addToFavouriteTemplate")}
            </Checkbox>
            { loading ?
                <div style={{ minWidth: '100px', marginTop: '10px', display: 'flex', justifyContent: 'flex-end', marginRight: '30px', alignItems: 'center'}}><div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div></div>
              : <Button
                  size={'large'}
                  htmlType="submit"
                  className="blue-button next_btn btn flex align_center justify_center"
              >
                {t("transfers.save")}
              </Button>
            }

          </Form> : <div className={'flex direction_column align_center justify_center full save_as_template_success_msg'}>
            {success ? 
            (<>
            <ModalSuccessIco />
            <p>{t("transfers.saved")}</p></>) : (<><ModalErrorIco /> <p>{t("notification.errorOccured")}</p></> )}
          </div>
        }

      </Modal>


    </>
  )
}

const mapDispatchToProps = { leftMenuToggle, saveTemplateLoading }

const mapStateToProps = (state: any, ownProps : any) => ({
  ownProps : ownProps,
  leftMenuStatus:  state.home.leftMenuStatus,
  companyData: (state.user &&  state.user.companyData.result) ?  state.user.companyData.result.customerNo  : getCurrentCompany()
})

export default connect(mapStateToProps, mapDispatchToProps)(SaveAsTemplate)
